module.exports = __webpack_public_path__ + "static/img/logo.c4af15e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo.png
// module id = 6PsS
// module chunks = 12